import { combineReducers } from 'redux';

import agents from './xAgentAgentsReducer';
import iaagents from './integrationAgentAgentsReducer';
import download from './xAgentDownloadInstallerReducer';
import supported from './xAgentSupportedVersionsReducer';
import userkey from './xAgentUserKeyReducer';
import loadstatus from './xAgentLoadingStateReducer';
import newAgent from './xAgentNewAgentReducer';
import tab from './xAgentTabReducer';
import pause from './xAgentPauseRefreshingReducer';

export default combineReducers({
  agents,
  iaagents,
  download,
  supported,
  userkey,
  loadstatus,
  newAgent,
  tab,
  pause,
});
